import React, {useState, useEffect} from 'react';
import {useCookies} from 'react-cookie';

import TermsModal from './TermsModal';
import {CONSENT_COOKIE_NAME} from '../../constants';
import {useSetModalContent} from '../../RootProvider/ModalContextProvider';

// Null render component to conditionally show modal. Must be used inside Modal context
function IncludeTermsModal(): null {
  const [cookies, _setCookie, removeCookie] = useCookies();
  const [isModalShown, setShowModal] = useState(false);
  const setModalContent = useSetModalContent();

  useEffect(() => {
    const consent = cookies[CONSENT_COOKIE_NAME];

    // check if we should show modal
    if (!isModalShown && !consent) {
      setShowModal(true);
      setModalContent(<TermsModal />);
    }

    // remove temp consent
    if (consent === 'temp') {
      removeCookie(CONSENT_COOKIE_NAME);
    }
  }, []);

  return null;
}

export default IncludeTermsModal;
